module.exports = __webpack_public_path__ + "img/info-dark.732fa928.svg";